import {Injectable} from '@angular/core';
import {firstValueFrom, map, of, tap} from "rxjs";
import {jwtDecode} from "jwt-decode";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Router} from '@angular/router';

interface Auth {
  id_token: string;
  access_token: string
}

interface JWTPayload extends Auth {
  iss: number;
  iat: number;
  exp: number;
}

export interface User extends JWTPayload {
  uuid: string;
  pidm: number;
  stud_no: string;
  ext_id: string;
  stud_name: string;
  gender: string;
  email: string;
  commencement_date?: string;
  normal_study_edate?: string;
  id_token: string;
  access_token: string;
  login_url: string;
  origin: string;
}

export const localhostMode = (): boolean => window.location.href.indexOf('localhost') > -1;
export const AimsAuthKey = 'AIMS_DIRECT_AUTH';
const SessAuthKey = 'AIMS-JWT-SESSION_' + (environment.production ? 'PROD' : 'STAGING');

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  jwtExpBufferSeconds = 300;
  user: User | null = null;

  constructor(private http: HttpClient, private router: Router) {
    const sessUser = sessionStorage.getItem(SessAuthKey);
    if (!!sessUser) {
      this.user = JSON.parse(sessUser);
    }
  }

  async initJwt(jwt: string): Promise<void> {
    if (!jwt) {
      await this.router.navigateByUrl('/unauth');
      return;
    }
    await firstValueFrom(this.refreshJWT(jwt));
    await this.router.navigateByUrl('/apply');
  }

  refreshJWT(oldJwt: string) {
    return this.http.get<Auth>(`${environment.authUrl}?old_jwt=${oldJwt}`)
      .pipe(
        map((res: Auth) => ({
          ...jwtDecode(res.id_token) as any,
          ...res
        })),
        tap((user: User) => {
          this.user = user;
          sessionStorage.setItem(SessAuthKey, JSON.stringify(user));
        }),
      );
  }

  obtainJWT() {
    if (!this.user) {
      // throw Error?
      return of({id_token: '', access_token: ''});
    }
    const currTime = Date.now() / 1000;
    const expTime = this.user.exp;
    if (expTime - currTime > this.jwtExpBufferSeconds) {
      return of({id_token: this.user.id_token, access_token: this.user.access_token});
    }
    return this.refreshJWT(this.user.id_token);
  }


}

